<template>
  <div>
    <van-loading type="spinner" />
  </div>
</template>

<script>
import { LinkPage, pageTypeConfig } from './hooks';
export default {
  data() {
    return {};
  },
  computed: {
    userId() {
      return this.$store.state.account.userId;
    },
    plazaId() {
      return this.$store.state.account.plazaId;
    },
    storeId() {
      return this.$store.state.account.storeId;
    },
    pageType() {
      return this.$store.state.base.pageType;
    },
  },
  methods: {},
  mounted() {
    let { pageType, caseCode, insureNum, projectType } = this.$route.query;
    pageType = pageType || this.pageType;


    const env = process.env.VUE_APP_ENV === 'production' ? 'production' : 'dev'

    let url = '';
    let data = {};
    let normal = {
      personnelId: this.userId,
      squareId: this.plazaId,
      storeId: this.storeId,
    };

    if (pageType == 'insure_complete') {
      url = '';
      data = {
        ...normal,
        caseCode,
      };
    } else if (pageType == 'insure_detail') {
      url = '/insureDetail';
      data = {
        ...normal,
        insureNum,
      };
    } else if (pageType == 'myPay') {
      location.href =
        'https://www.bxy18.com/index?bindingSource=110&caseSource=48&isMember=0';
      return;
    } else if (pageType == 'myBill') {
      url = '/insureList';
      data = {
        personnelId: this.userId,
      };
    } else if (pageType == 'insure_operating' || pageType == 'insure_building' || pageType == 'insure_service') {
      // 经营期保险 // 施工期保险  // 服务商保险
      url = '/index';
      data = {
        ...normal,
        personnelId: this.userId,
        storeId: this.storeId,
        media: pageTypeConfig[pageType].media,
        // media: projectType == 1 ? '510' :'515',
        // project:projectType
      };
    } else if (pageType == 'insure_index') {
      url = '/index',
        data = {
          media: pageTypeConfig[pageType].media
        }
    } else {
      url = '';
      data = {
        ...normal,
        caseCode,
      };
    }



    if (projectType == 1) {
      // 万达
      data.project = projectType
      switch (pageType) {
      case 'insure_operating':
        data.media = env == 'production' ? '14906' : '509'

        break;
      case 'insure_building':
        data.media = env == 'production' ? '14905' : '509'

        break;
      case 'insure_service':
        data.media = env == 'production' ? '14909' : '509'

        break;

      default:
        break;
      }
    } else if (projectType == 2 || projectType == 3) {
      // 金街、其他
      switch (pageType) {
      case 'insure_operating':
        data.media = env == 'production' ? '14957' : '515'

        break;
      case 'insure_building':
        data.media = env == 'production' ? '14958' : '515'

        break;

      default:
        break;
      }
      data.project = projectType
    }
    if(localStorage.getItem('insure_shareInfo')){
      data = {
        ...data,
        ...JSON.parse(localStorage.getItem('insure_shareInfo'))
      }
    }
    console.log(LinkPage(url, data));
    // window.location.href = LinkPage(url, data)
    // window.event.returnValue = false
    // window.open(LinkPage(url, data), '_self');
    // window.onpageshow = function (e) {
    //   if (e.persisted) {
    //     window.location.reload();
    //   }
    // };
    // window.location.href = LinkPage(url, data)

    window.location.replace(LinkPage(url, data))

  },
};
</script>

<style></style>